import React, { useState, useEffect } from "react";
import {
  Form,
  Col,
  Container,
  Dropdown,
  DropdownButton,
  Row,
} from "react-bootstrap";
import Select from "react-select";
import DataTable from "react-data-table-component";
import { REPORTS } from "../../configurations/Urls";
import WellReportService from "../../api-service/WellReportService";
import _ from "lodash";
import SessionHelper from "../../helpers/SessionHelper";
import { debounce } from "lodash";
import StorageHelper from "../../helpers/StorageHelper";
import SuperUserService from "../../api-service/SuperUserService";
import DashboardHelper from "../../helpers/DashboardHelper";
import LoadingOverlay from "../common/LoadingOverlay";
import {
  DEBOUNCE_SEARCH_WAITING_TIME,
  EMPTY,
  STAFF_SESSION_EXPIRED,
} from "../../configurations/Constants";
import { StatusCodes } from "../../configurations/status-codes";
import {
  ERROR_DOWNLOADING_WELL_REPORT,
  ERROR_LOADING_FARMER_LIST,
  ERROR_LOADING_WELL_IRRIG_UNIT_LIST,
  INCOMING_TOKEN_HAS_EXPIRED,
  STAFF_AUTHORIZED,
} from "../../configurations/MessageConstants";
import MessageBanner from "../common/MessageBanner";

const SearchBox = ({ onSearch, value }) => (
  <Form.Control
    type="text"
    defaultValue={value}
    name="searchValue"
    onChange={onSearch}
    placeholder="Search"
    className="form-control form-control-lg me-2 staff-report-search w-100"
  />
);

const Export = ({ onExport }) => (
  <DropdownButton
    id="dropdown-basic-button"
    title={
      <span>
        Export <i className="fa fa-download ms-2" aria-hidden="true"></i>
      </span>
    }
  >
    <Dropdown.Item onClick={() => onExport("pdf")}>Export as PDF</Dropdown.Item>
    <Dropdown.Item onClick={() => onExport("xlsx")}>
      Export as XLSX
    </Dropdown.Item>
  </DropdownButton>
);

function WellChemigationReport(props) {
  const [wellId, setWellId] = useState(null);
  const [irrigUnitId, setIrrigUnitId] = useState(null);
  const [wellActive, setWellActive] = useState(null);
  const [wellTest, setWellTest] = useState(null);
  const [searchValue, setSearchValue] = useState(null);
  const [column, setColumn] = useState(null);
  const [columnOrder, setColumnOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [exportURL, setExportURL] = useState(EMPTY);
  const [overlayLoading, setOverlayLoading] = useState(false);
  const [data, setData] = useState([]);
  const [allWellOptions, setAllWellOptions] = useState([]);
  const [allIrrigUnitOptions, setAllIrrigUnitOptions] = useState([]);
  const [farmer, setFarmer] = useState(null);
  const [farmersList, setFarmersList] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const yearArray = DashboardHelper.setYearDataArray([]);

  const columns = [
    {
      id: 1,
      name: "Well ID",
      selector: (row) => row.well_id,
      sortable: true,
      reorder: true,
      width: "8rem",
      value: "well_id",
    },
    {
      id: 2,
      name: "Name",
      selector: (row) => row.user_name,
      sortable: true,
      reorder: true,
      width: "13rem",
      value: "user_name",
    },
    {
      id: 3,
      name: "Field Name",
      selector: (row) => row.field_name,
      sortable: true,
      reorder: true,
      width: "13rem",
      value: "field_name",
    },

    {
      id: 4,
      name: "Well Active",
      selector: (row) => row.is_active_icon,
      sortable: true,
      reorder: true,
      width: "8rem",
      value: "is_active",
    },
    {
      id: 5,
      name: "Well Test",
      selector: (row) => row.well_test_icon,
      sortable: true,
      reorder: true,
      width: "8rem",
      value: "well_test",
    },
    {
      id: 6,
      name: "Pump Rate",
      selector: (row) => row.pump_rate,
      sortable: true,
      reorder: true,
      width: "8rem",
      value: "pump_rate",
    },

    {
      id: 7,
      name: "Last Well Test",
      selector: (row) => row.last_tested,
      sortable: true,
      reorder: true,
      width: "8rem",
      value: "last_tested",
    },
    {
      id: 8,
      name: "Irrig Unit ID",
      selector: (row) => row.irrig_unit_id,
      sortable: true,
      reorder: true,
      width: "8rem",
      value: "irrig_unit_id",
    },
    {
      id: 9,
      name: "Permit Number",
      selector: (row) => row.permit_number,
      sortable: true,
      reorder: true,
      width: "9rem",
      value: "permit_number",
    },
    {
      id: 10,
      name: "Permit Holder",
      selector: (row) => row.permit_holder,
      sortable: true,
      reorder: true,
      width: "12rem",
      value: "permit_holder",
      cell: (row) => (
        <div className="staff-report-row-item-hover" title={row.permit_holder}>
          {row.permit_holder}
        </div>
      ),
    },
    {
      id: 11,
      name: "Applicators",
      selector: (row) => row.applicators,
      sortable: true,
      reorder: true,
      width: "12rem",
      value: "applicators",
      cell: (row) => (
        <div className="staff-report-row-item-hover" title={row.applicators}>
          {row.applicators}
        </div>
      ),
    },
    {
      id: 12,
      name: "Chemical Nickname",
      selector: (row) => row.chem_nickname,
      sortable: true,
      reorder: true,
      width: "10rem",
      value: "chem_nickname",
    },
    {
      id: 13,
      name: "Last Inspection Date",
      selector: (row) => row.last_inspect_date,
      sortable: true,
      reorder: true,
      width: "11rem",
      value: "last_inspect_date",
    },
  ];

  useEffect(() => {
    (async function () {
      try {
        const { data } = await SuperUserService.getFarmerList();
        setFarmersList(data.data.users);
        await getWellAndIrrigsData();
      } catch (error) {
        console.error(ERROR_LOADING_FARMER_LIST, error);
      }
    })();
  }, []);

  useEffect(() => {
    setLoading(true);
    fetchWellReports(
      currentPage,
      perPage,
      wellId,
      wellActive,
      irrigUnitId,
      wellTest,
      searchValue,
      farmer,
      selectedYear,
      column,
      columnOrder
    );
  }, [
    currentPage,
    perPage,
    wellId,
    wellActive,
    irrigUnitId,
    wellTest,
    searchValue,
    farmer,
    selectedYear,
    column,
    columnOrder,
  ]);

  const getWellAndIrrigsData = async () => {
    let allWellsAndIrrigsData = {};
    try {
      let response = await WellReportService.getWellAndIrrigs();
      allWellsAndIrrigsData = response.data.data;
      generateWellAndIrrigsArray(allWellsAndIrrigsData);
    } catch (error) {
      console.error(ERROR_LOADING_WELL_IRRIG_UNIT_LIST, error);
      return false;
    }
  };

  const generateWellAndIrrigsArray = async (wellsAndIrrigs) => {
    let WellsArray = [];
    let IrrigUnitsArray = [];
    _.forEach(wellsAndIrrigs.irrig_wells, (value) => {
      let wellsObj = {};
      wellsObj.value = value;
      wellsObj.label = value;
      WellsArray.push(wellsObj);
    });
    _.forEach(wellsAndIrrigs.irrig_units, (value) => {
      let IrrigsObj = {};
      IrrigsObj.value = value;
      IrrigsObj.label = value;
      IrrigUnitsArray.push(IrrigsObj);
    });
    setAllWellOptions(WellsArray);
    setAllIrrigUnitOptions(IrrigUnitsArray);
  };

  const fetchWellReports = async (
    page,
    size,
    wellId,
    wellActive,
    irrigUnitId,
    wellTest,
    searchValue,
    farmer,
    selectedYear,
    column,
    columnOrder
  ) => {
    setLoading(true);
    let params = `?current_pg=${page}`;
    if (size) {
      params = `${params}&rows_per_pg=${size}`;
    }
    if (wellId !== null) {
      params = `${params}&well_id=${wellId.value}`;
    }
    if (wellActive !== null) {
      params = `${params}&is_active=${wellActive.value}`;
    }
    if (irrigUnitId !== null) {
      params = `${params}&irrig_unit_id=${irrigUnitId.value}`;
    }
    if (wellTest !== null) {
      params = `${params}&is_tested=${wellTest.value}`;
    }
    if (searchValue) {
      params = `${params}&search_text=${searchValue}`;
    }
    if (farmer) {
      params = `${params}&user=${farmer.value}`;
    }
    if (selectedYear) {
      params = `${params}&year=${selectedYear.value}`;
    }
    if (column !== null) {
      params = `${params}&column=${column}`;
    }
    if (columnOrder !== null) {
      params = `${params}&column_order=${columnOrder}`;
    }
    const url = `${REPORTS}/chemigation${params}`;
    const exporturl = `${REPORTS}/chemigation/export${params}`;
    try {
      const response = await WellReportService.getWellReports(url);
      let reportData = response.data.data;
      if (reportData) {
        _.forEach(reportData.data, (value) => {
          value.is_active_icon = handleTableIcons(value.is_active);
          value.well_test_icon = handleTableIcons(value.well_test);
        });
        setExportURL(exporturl);
        setData(reportData.data);
        setTotalRows(reportData.totalRows);
        setLoading(false);
      }
    } catch (error) {
      const responseData = error.response.data;
      if (
        error.response.status === StatusCodes.UNAUTHORIZED &&
        responseData.message.includes(INCOMING_TOKEN_HAS_EXPIRED)
      ) {
        StorageHelper.setItem(STAFF_SESSION_EXPIRED, true);
        SessionHelper.cleanUpStorageKeys();
        window.location.reload();
      }
    }
  };

  const handleTableIcons = (value) => {
    if (!value) {
      return (
        <i
          className="fa-solid fa-xmark staff-report-cross"
          aria-hidden="true"
        ></i>
      );
    }
    return (
      <i className="fa-solid fa-check staff-report-tick" aria-hidden="true"></i>
    );
  };

  const handleSearchValue = async (e) => {
    await debouncedSearch(e.target.value);
  };
  const debouncedSearch = debounce(async (value) => {
    setSearchValue(value);
  }, DEBOUNCE_SEARCH_WAITING_TIME);

  const handleSort = async (column, sortDirection) => {
    setColumn(column.value);
    setColumnOrder(sortDirection);
  };

  const downloadCSV = async (url) => {
    setOverlayLoading(true);
    try {
      const response = await WellReportService.exportReports(url);
      const filenameRegex = /filename="(.*)"/;
      const matches = filenameRegex.exec(
        response.headers["content-disposition"]
      );
      const fileName = matches && matches[1] ? matches[1] : "well_report.xlsx";
      let blob = await response.data;
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      setOverlayLoading(false);
    } catch (error) {
      setOverlayLoading(false);
      const responseData = error.response.data;
      if (
        error.response.status === StatusCodes.UNAUTHORIZED &&
        responseData.message.includes(INCOMING_TOKEN_HAS_EXPIRED)
      ) {
        StorageHelper.setItem(STAFF_SESSION_EXPIRED, true);
        SessionHelper.cleanUpStorageKeys();
        window.location.reload();
      }
      console.error(ERROR_DOWNLOADING_WELL_REPORT, error);
    }
  };

  return (
    <div className="staff-report">
      <LoadingOverlay
        showSpinner={true}
        active={overlayLoading}
        text="Exporting Data..."
      />
      <MessageBanner
        title={"Well Chemigation Report"}
        description={STAFF_AUTHORIZED}
      />
      <Container className="p-3 staff-report-body">
        <Row>
          <Form.Group as={Col} controlId="WellRegistration" md={2}>
            <Select
              isClearable={true}
              name="wellId"
              options={allWellOptions}
              className="basic-multi-select staff-report-filters"
              onChange={setWellId}
              value={wellId}
              placeholder={
                <div>
                  <span className="staff-report-filter-placeholder-large">
                    Well ID
                  </span>
                  <span className="staff-report-filter-placeholder-small">
                    Well
                  </span>
                </div>
              }
            />
          </Form.Group>
          <Form.Group as={Col} controlId="WellActive" md={2}>
            <Select
              isClearable={true}
              name="wellActive"
              options={[
                { value: true, label: "Yes" },
                { value: false, label: "No" },
              ]}
              className="basic-multi-select staff-report-filters"
              onChange={setWellActive}
              value={wellActive}
              isSearchable={false}
              placeholder={
                <div>
                  <span className="staff-report-filter-placeholder-large">
                    Well Active
                  </span>
                  <span className="staff-report-filter-placeholder-small">
                    Active
                  </span>
                </div>
              }
            />
          </Form.Group>
          <Form.Group as={Col} controlId="WellTest" md={2}>
            <Select
              isClearable={true}
              name="wellTest"
              options={[
                { value: true, label: "Yes" },
                { value: false, label: "No" },
              ]}
              className="basic-multi-select staff-report-filters"
              onChange={setWellTest}
              value={wellTest}
              isSearchable={false}
              placeholder={
                <div>
                  <span className="staff-report-filter-placeholder-large">
                    Well Tested
                  </span>
                  <span className="staff-report-filter-placeholder-small">
                    Tested
                  </span>
                </div>
              }
            />
          </Form.Group>
          <Form.Group as={Col} controlId="IrrigUnitId" md={3}>
            <Select
              isClearable={true}
              name="irrigUnitId"
              options={allIrrigUnitOptions}
              className="basic-multi-select staff-report-filters"
              onChange={setIrrigUnitId}
              value={irrigUnitId}
              placeholder={
                <div>
                  <span className="staff-report-filter-placeholder-large">
                    Irrig Unit ID
                  </span>
                  <span className="staff-report-filter-placeholder-small">
                    Irrig Unit ID
                  </span>
                </div>
              }
            />
          </Form.Group>
          <Form.Group as={Col} controlId="FarmerData" md={3}>
            <Select
              name="farmerData"
              options={farmersList}
              isClearable={true}
              className="staff-report-farmer-filter basic-multi-select w-100"
              onChange={setFarmer}
              value={farmer}
              placeholder={
                <div>
                  <span className="staff-report-filter-placeholder-large">
                    Farmer
                  </span>
                  <span className="staff-report-filter-placeholder-small">
                    Farmer
                  </span>
                </div>
              }
            />
          </Form.Group>
        </Row>
        <Row className="mb-2 mt-4 staff-report-heading ms-1">
          <Col lg={4}>
            <h3 className="mt-2">Well Chemigation Report</h3>
          </Col>
          <Col lg={8}>
            <div className="d-flex justify-content-end flex-grow-1 ms-0 staff-report-heading-filters">
              <div className="d-flex staff-report-heading-first-row-filters">
                <Select
                  name="yearData"
                  options={yearArray}
                  isClearable={true}
                  className="staff-report-year-filter basic-multi-select w-100"
                  onChange={setSelectedYear}
                  value={selectedYear}
                  placeholder={
                    <div>
                      <span className="staff-report-filter-placeholder-large">
                        Well Test Year
                      </span>
                      <span className="staff-report-filter-placeholder-small">
                        Well Test Year
                      </span>
                    </div>
                  }
                />
              </div>
              <div className="d-flex staff-report-heading-second-row-filters gap-2">
                <SearchBox
                  onSearch={(e) => handleSearchValue(e, searchValue)}
                />
                <Export
                  onExport={(item) => downloadCSV(`${exportURL}&type=${item}`)}
                />
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <DataTable
            columns={columns}
            data={data}
            progressPending={loading}
            pagination
            paginationServer
            sortServer
            onSort={handleSort}
            paginationTotalRows={totalRows}
            paginationDefaultPage={currentPage}
            onChangeRowsPerPage={setPerPage}
            onChangePage={setCurrentPage}
            paginationRowsPerPageOptions={[10, 25, 50, 100]}
          />
        </Row>
      </Container>
    </div>
  );
}

export default WellChemigationReport;
